import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = () => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('date.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('export.user.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('export.user_type.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('export.name.label')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader />
  </TableCell>
</>

export default React.memo(Header)
